<template>
  <b-card class="mt-4">
    <b-row>
      <b-col cols="3">
        <vue-tree-navigation :items="items" v-if="items.length > 0" :defaultOpenLevel="defaultOpenLevel" />
        <div>
          <b-btn v-show="!addRootElement" variant="outline-secondary" @click="addRootElement = true" size="sm">Dodaj</b-btn>
          <b-input-group v-show="addRootElement">
            <b-input-group-prepend>
              <b-button
                size="sm"
                @click="
                  rootElementInput = '';
                  addRootElement = false;
                "
                variant="outline-danger"
              >
                <i class="far fa-window-close"></i>
              </b-button>
            </b-input-group-prepend>
            <b-input v-model="rootElementInput" class></b-input>
            <b-input-group-append>
              <b-button size="sm" variant="outline-primary" @click="createRootNode">Zapisz</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-col>
      <b-col v-if="currentNode" cols="9">
        <h3>
          {{ currentNode.name }}
          <b-btn v-b-tooltip.hover title="Zmień węzeł nadrzędny" class="btn-xs" @click.stop="showTreeStructModal(currentNode)">Przenieś</b-btn>
          <b-btn
            class="float-right"
            variant="outline-danger"
            size="sm"
            @click.stop="
              selectedNode = currentNode;
              confirmModal = true;
            "
            >Usuń</b-btn
          >
          <b-btn class="float-right mx-1" variant="outline-primary" size="sm" @click.stop="showEditModal(currentNode)">Edytuj</b-btn>
        </h3>
        <div>
          <h5 class="pt-3 pb-2">
            Podległe węzły
            <b-btn class="float-right" size="sm" @click="createChildModal = true" variant="outline-primary">Dodaj węzeł</b-btn>
          </h5>
          <b-list-group>
            <b-list-group-item @click="navigateToChild(child.id)" v-for="child in currentNode.children" :key="child.id" button>
              {{ child.name }}
              <b-btn v-b-tooltip.hover title="Zmień węzeł nadrzędny" class="btn-xs" @click.stop="showTreeStructModal(child)">Przenieś</b-btn>
              <b-btn
                @click.stop="
                  selectedNode = child;
                  confirmModal = true;
                "
                class="float-right"
                variant="outline-danger"
                size="sm"
                >Usuń</b-btn
              >
              <b-btn class="float-right mx-1" variant="outline-primary" size="sm" @click.stop="showEditModal(child)">Edytuj</b-btn>
            </b-list-group-item>
          </b-list-group>
        </div>
      </b-col>
    </b-row>
    <b-modal
      v-if="currentNode"
      v-model="createChildModal"
      :title="'Dodaj węzeł do ' + currentNode.name"
      cancel-title="Anuluj"
      ok-title="Dodaj"
      @ok="createNode"
      @cancel="newChildName = ''"
    >
      <b-form-group label="Nazwa węzła">
        <b-form-input v-model="newChildName"></b-form-input>
      </b-form-group>
    </b-modal>
    <confirm-modal v-if="confirmModal" :confirmModal="confirmModal" @cancel="hideConfirmModal" @ok="deleteNode">
      <span slot="body">Czy na pewno chcesz usunąć {{ selectedNode.name }}?</span>
    </confirm-modal>
    <edit-modal v-if="editModalShow" :show="editModalShow" :node="selectedNode" @cancel="hideEditModal" @edited="nodeEdited"></edit-modal>
    <tree-struct v-if="treeStructShow" :show="treeStructShow" :item="selectedNode" @cancel="hideTreeStructModal" @tree="updateTreeStruct"></tree-struct>
  </b-card>
</template>
<script>
import ConfirmModal from '@/components/ConfirmModal.vue';
import editModal from './modals/editModal.vue';
import treeStruct from './modals/treeStruct.vue';
import { LogicalStructureResource } from '@/resources/logicalStructure.resource';

export default {
  components: {
    ConfirmModal,
    editModal,
    treeStruct
  },
  data() {
    return {
      currentId: null,
      currentNode: null,
      items: [],
      defaultOpenLevel: 0,
      newChildName: '',
      confirmModal: false,
      selectedNode: null,
      createChildModal: false,
      pickedNode: null,
      treeStructShow: false,
      addRootElement: false,
      rootElementInput: '',
      editModalShow: false
    };
  },
  methods: {
    async getLogicalStructure() {
      try {
        const tree = (await LogicalStructureResource.fullList()).map(item => {
          item.path = 'logicalStructure/' + item.id;
          this.setPath(item);
          return item;
        });
        this.$set(this, 'items', tree);
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },
    setPath(node) {
      if (node.children) {
        node.children.forEach(child => {
          child.path = '' + child.id;
          this.setPath(child);
        });
      }
    },
    getCurrentId() {
      const path = this.$route.path;
      const arr = path.split('/');
      this.currentId = parseInt(arr[arr.length - 1], 10);
      this.getNode();
    },
    async getNode() {
      try {
        if (!this.currentId) {
          return;
        }
        this.$set(this, 'currentNode', await LogicalStructureResource.get(parseInt(this.currentId, 10)));
      } catch (error) {
        console.warn(error);
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },
    async deleteNode() {
      const id = parseInt(this.selectedNode.id, 10);
      try {
        await LogicalStructureResource.delete(id);
        this.currentNode.children.splice(this.currentNode.children.findIndex(child => child.id === id), 1);
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },
    navigateToChild(id) {
      this.$router.push({ path: this.$route.path + '/' + id });
    },
    showTreeStructModal(node) {
      this.treeStructShow = true;
      this.selectedNode = node;
    },
    hideTreeStructModal() {
      this.treeStructShow = false;
      this.selectedNode = null;
    },
    updateTreeStruct(node, oldParentId) {
      this.hideTreeStructModal();
      this.currentNode = null;
      this.changeTreeNav(this.items, node, oldParentId);
      this.$router.push('/logicalStructure');
    },
    changeTreeNav(array, node, oldParentId) {
      array.forEach(item => {
        if (item.id === oldParentId) {
          if (item.children) {
            if (item.children.length === 1) {
              item.hasChildren = false;
              item.children = undefined;
            } else {
              item.children.splice(item.children.findIndex(child => child.id === node.id), 1);
            }
          }
        }
        if (item.id === node.parentId) {
          if (!item.children) {
            item.hasChildren = true;
            item.children = [];
          }
          node.path = '' + node.id;
          item.children.push(node);
        }
        if (item.children && item.children.length > 0) {
          this.changeTreeNav(item.children, node, oldParentId);
        }
      });
    },
    hideConfirmModal() {
      this.confirmModal = false;
    },
    async createNode() {
      if (!this.newChildName) {
        return;
      }
      try {
        const addedNode = await LogicalStructureResource.add(this.newChildName, parseInt(this.currentId, 10));
        this.currentNode.children.push(addedNode);
      } catch (error) {
        this.$notify({ type: 'error', title: 'Błąd', text: error.message });
      }
    },
    async createRootNode() {
      try {
        const { data } = (data.nodeRootCreate.path = 'logicalStructure/' + data.nodeRootCreate.id);
        this.items.push(data.nodeRootCreate);
        this.rootElementInput = '';
        this.addRootElement = false;
      } catch (error) {
        console.warn(error);
      }
    },
    showEditModal(node) {
      this.selectedNode = node;
      this.editModalShow = true;
    },
    hideEditModal() {
      this.selectedNode = null;
      this.editModalShow = false;
    },
    nodeEdited(node) {
      if (node.id === this.currentNode.id) {
        this.currentNode.name = node.name;
        this.updateTree(this.items, node);
      } else {
        this.$set(this.currentNode.children.find(e => e.id === node.id), 'name', node.name);
        this.updateTree(this.items, node);
      }
      this.hideEditModal();
    },
    updateTree(array, element) {
      array.forEach(node => {
        if (node.id === element.id) {
          node.name = element.name;
        } else {
          if (node.children) {
            this.updateTree(node.children, element);
          }
        }
      });
    }
  },
  watch: {
    $route() {
      this.getCurrentId();
    }
  },
  beforeMount() {
    this.getLogicalStructure();
    this.getCurrentId();
  }
};
</script>
<style scoped>
ul {
  list-style: none !important;
  list-style-type: none !important;
}
.btn-xs {
  font-size: 0.8em !important;
  padding: 0em 0.4em !important;
  margin: 0em 0.4em 0.2em !important;
}
</style>
